// Fly.io public regions, as of 2026.
// https://fly.io/docs/reference/regions/
export const FLY_REGIONS: { code: string; label: string }[] = [
  { code: "ams", label: "Amsterdam, NL" },
  { code: "arn", label: "Stockholm, SE" },
  { code: "atl", label: "Atlanta, US" },
  { code: "bog", label: "Bogotá, CO" },
  { code: "bom", label: "Mumbai, IN" },
  { code: "bos", label: "Boston, US" },
  { code: "cdg", label: "Paris, FR" },
  { code: "den", label: "Denver, US" },
  { code: "dfw", label: "Dallas, US" },
  { code: "ewr", label: "Newark, US" },
  { code: "eze", label: "Buenos Aires, AR" },
  { code: "fra", label: "Frankfurt, DE" },
  { code: "gdl", label: "Guadalajara, MX" },
  { code: "gig", label: "Rio de Janeiro, BR" },
  { code: "gru", label: "São Paulo, BR" },
  { code: "hkg", label: "Hong Kong" },
  { code: "iad", label: "Ashburn, US" },
  { code: "jnb", label: "Johannesburg, ZA" },
  { code: "lax", label: "Los Angeles, US" },
  { code: "lhr", label: "London, UK" },
  { code: "mad", label: "Madrid, ES" },
  { code: "mia", label: "Miami, US" },
  { code: "nrt", label: "Tokyo, JP" },
  { code: "ord", label: "Chicago, US" },
  { code: "otp", label: "Bucharest, RO" },
  { code: "phx", label: "Phoenix, US" },
  { code: "qro", label: "Querétaro, MX" },
  { code: "scl", label: "Santiago, CL" },
  { code: "sea", label: "Seattle, US" },
  { code: "sin", label: "Singapore" },
  { code: "sjc", label: "San Jose, US" },
  { code: "syd", label: "Sydney, AU" },
  { code: "waw", label: "Warsaw, PL" },
  { code: "yul", label: "Montreal, CA" },
  { code: "yyz", label: "Toronto, CA" },
];

export function regionLabel(code: string | null | undefined): string {
  if (!code) return "unknown";
  const found = FLY_REGIONS.find((r) => r.code === code);
  return found ? `${code} (${found.label})` : code;
}
